import "./UpdateTickeSolved.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import newRequest from "../../context/newRequest";
import {sleep} from "../../helper/helper";

const UpdateTicketSolved = ({ title }) => {
  const [ticketSolved, setTicketSolved] = useState({});
  const [ticketUpdateSolved, setTicketUpdateSolved] = useState({});
  const [categoryId, setCategoryId] = useState(false);
  const [statusId, setStatusId] = useState(false);
  const [sending, setSending] = useState("");
  const { ticketId } = useParams();
  const { data } = useFetch(`/solve/${ticketId}`);
  const navigate = useNavigate();

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setTicketSolved(data);
      setTicketUpdateSolved({
        segment_customer: data.segment_customer || "",
        summary: data.summary || "",
        action: data.action || "",
        note: data.note || "",
      });
      if (data.status_id) {
        setStatusId([data.status_id]);
      }
      if (data.category_id) {
        setCategoryId([data.category_id]);
      }
    }
  }, [data]);

  const handleSelectCategoryID = (e) => {
    const value = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );
    setCategoryId(value);
  };

  const handleSelectStatusID = (e) => {
    const value = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );
    setStatusId(value);
  };

  const handleChange = (e) => {
    setTicketUpdateSolved((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();
    setSending("Mengirim Data...");
    try {
      const newTicketUpdate = {
        ...ticketUpdateSolved,
        category_id: categoryId && categoryId.length > 0 ? categoryId[0] : (ticketSolved.category_id || "DOWN"),
        status_id: statusId && statusId.length > 0 ? statusId[0] : (ticketSolved.status_id || "SOLVED"),
      };

      const res = await newRequest.put(`/solve/${ticketId}`, newTicketUpdate);
      if (res.status === 200) {
        setSending("Berhasil Mengirim Data");
        await sleep(1000);
        navigate(`/solve/${ticketId}`);
      }
    } catch (err) {
      console.error("Error updating ticket solved:", err);
      const errMsg = err.response?.data?.errors || err.response?.data?.message || err.message || "Gagal mengupdate tiket";
      setSending(errMsg);
    }
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <div className="detailItem">
              <span className="itemKey">Ticket ID:</span>
              <span className="itemValue">{ticketId}</span>
            </div>
            <form>
              <div className="formInput">
                <label>Segment Customer</label>
                <input
                  type="text"
                  placeholder={ticketSolved.segment_customer || "Segment Customer"}
                  value={ticketUpdateSolved.segment_customer ?? ""}
                  onChange={handleChange}
                  id="segment_customer"
                />
              </div>

              <div className="formInput">
                <label>Summary (Root Cause)</label>
                <input
                  type="text"
                  placeholder={ticketSolved.summary || "Summary"}
                  value={ticketUpdateSolved.summary ?? ""}
                  onChange={handleChange}
                  id="summary"
                />
              </div>

              <div className="formInput">
                <label>Action (Tindakan)</label>
                <input
                  type="text"
                  placeholder={ticketSolved.action || "Action"}
                  value={ticketUpdateSolved.action ?? ""}
                  onChange={handleChange}
                  id="action"
                />
              </div>

              <div className="formInput">
                <label className="label">Status</label>
                <select
                  id="status_id"
                  value={statusId[0] || ticketSolved.status_id || "SOLVED"}
                  onChange={handleSelectStatusID}
                >
                  <option value="OPEN">Open</option>
                  <option value="PENDING">Pending</option>
                  <option value="SOLVED">Solved</option>
                  <option value="CLOSED">CLOSED</option>
                </select>
              </div>

              <div className="formInput">
                <label className="label">Category</label>
                <select
                  id="category_id"
                  value={categoryId[0] || ticketSolved.category_id || "DOWN"}
                  onChange={handleSelectCategoryID}
                >
                  <option value="DOWN">Down</option>
                  <option value="UP">UP Internet</option>
                  <option value="ONUBAD">ONU Bad</option>
                  <option value="FIBERCUT">Fiber Cut</option>
                  <option value="POWEROFF">Power OFF</option>
                  <option value="INTERMITTEN">INTERMITTEN</option>
                  <option value="LOOPING">LOOPING</option>
                  <option value="BENDING">BENDING</option>
                </select>
              </div>

              <div className="formInput">
                <label>Note (Catatan Tiket)</label>
                <textarea
                  id="note"
                  placeholder="Tambahkan catatan khusus untuk tiket ini..."
                  value={ticketUpdateSolved.note ?? ""}
                  onChange={handleChange}
                  rows="3"
                  style={{
                    width: "100%",
                    padding: "8px 10px",
                    border: "1px solid #cbd5e1",
                    borderRadius: "6px",
                    fontFamily: "inherit",
                    fontSize: "14px",
                    resize: "vertical",
                    marginTop: "5px",
                    boxSizing: "border-box"
                  }}
                />
              </div>

              <button onClick={handleClick} disabled={sending === "Mengirim Data..."}>
                {sending === "Mengirim Data..." ? "Menyimpan..." : "Update Ticket"}
              </button>
            </form>
          </div>
        </div>
        {sending && <p className="error">{sending}</p>}
      </div>
    </div>
  );
};

export default UpdateTicketSolved;
